module.exports = __webpack_public_path__ + "img/dataManagement-1.80d56975.png";